var _typeof = require('./typeof.js')['default'];
var assertThisInitialized = require('./assertThisInitialized.js');
function _possibleConstructorReturn(t, e) {
    if (e && ('object' == _typeof(e) || 'function' == typeof e))
        return e;
    if (void 0 !== e)
        throw new TypeError('Derived constructors may only return object or undefined');
    return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports['default'] = module.exports;